var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import ChargesTable from "./ChargesTable";
import { useSelector } from "react-redux";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import Loader from "@frameworks/shared-library/components/Loader";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
import { padZeros } from "../../../ClientBody/constants";
import { addCommas } from "@domains/utils/numberMethods";
var DelayedFno = function (props) {
    var _a;
    var _b = __read(React.useState(), 2), delayedFnoDetails = _b[0], setDelayedFnoDetails = _b[1];
    var _c = __read(useState(), 2), totalData = _c[0], setTotalData = _c[1];
    var _d = __read(React.useState(false), 2), fnoLoader = _d[0], setFnoLoader = _d[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var getFnoDetailsData = function (accCode) {
        setFnoLoader(true);
        var req = {
            acCode: accCode,
        };
        di.clients
            .getRevenueFnoMarginData(req)
            .then(function (resp) {
            if (resp && resp.fnoDetails) {
                setDelayedFnoDetails({
                    fnoDetails: resp,
                    fnoDetailsError: "",
                });
            }
            else {
                setDelayedFnoDetails({
                    fnoDetails: null,
                    fnoDetailsError: "No Data Found",
                });
            }
            setFnoLoader(false);
        })
            .catch(function (error) {
            setFnoLoader(false);
            setDelayedFnoDetails({
                fnoDetails: null,
                fnoDetailsError: "No Data Found",
            });
        });
    };
    React.useEffect(function () {
        var _a, _b, _c;
        if (delayedFnoDetails &&
            (delayedFnoDetails === null || delayedFnoDetails === void 0 ? void 0 : delayedFnoDetails.fnoDetails) &&
            ((_b = (_a = delayedFnoDetails === null || delayedFnoDetails === void 0 ? void 0 : delayedFnoDetails.fnoDetails) === null || _a === void 0 ? void 0 : _a.fnoDetails) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            var totalData_1 = 0;
            (_c = delayedFnoDetails === null || delayedFnoDetails === void 0 ? void 0 : delayedFnoDetails.fnoDetails) === null || _c === void 0 ? void 0 : _c.fnoDetails.map(function (record) {
                totalData_1 += record.value;
            });
            setTotalData(totalData_1);
        }
    }, [delayedFnoDetails]);
    React.useEffect(function () {
        if (selectedAcount && (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode))
            getFnoDetailsData(selectedAcount.accountCode);
    }, [selectedAcount]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 px-0 dpledger-block" },
            React.createElement(Row, { className: "px-0 mx-0" },
                React.createElement(Col, { className: "px-0 HeadRow d-flex justify-content-between align-items-center" },
                    React.createElement("span", { className: "DMSansNormal_20_400 txt" },
                        React.createElement("i", { className: "edel-icon-arrow-left1", onClick: function () {
                                props.closePopup(false);
                            } }),
                        "Delayed Payment Charges FNO - Accode :",
                        " ", selectedAcount === null || selectedAcount === void 0 ? void 0 :
                        selectedAcount.accountCode)))),
        React.createElement(Row, { className: "px-0 mx-0 payment-popuptable-block delayed-fno" },
            React.createElement(Row, { className: "mx-0 payment-popuptable-mainhead" },
                React.createElement(Col, { className: "px-0 DMSansMedium_12_500 txt_primaryGrey" }, "Month - Year"),
                React.createElement(Col, { className: "px-0 DMSansMedium_12_500 txt_primaryGrey taRight" }, "Interest Amount (Rs)")),
            React.createElement(Row, { className: "mx-0" },
                fnoLoader && (React.createElement("div", { className: "position-relative client-loader" },
                    React.createElement(Loader, null))),
                !fnoLoader && !!(delayedFnoDetails === null || delayedFnoDetails === void 0 ? void 0 : delayedFnoDetails.fnoDetailsError) && (React.createElement(ErrorNotification, { displayType: ErrorDisplayType.INSECTION, errMsg: delayedFnoDetails === null || delayedFnoDetails === void 0 ? void 0 : delayedFnoDetails.fnoDetailsError, isOpen: true })),
                !fnoLoader && (React.createElement(ChargesTable, { revenueDetails: (_a = delayedFnoDetails === null || delayedFnoDetails === void 0 ? void 0 : delayedFnoDetails.fnoDetails) === null || _a === void 0 ? void 0 : _a.fnoDetails }))),
            React.createElement(Row, { className: "mx-0 payment-popuptable-mainhead" },
                React.createElement(Col, { className: "px-0 DMSanM_14_500 txt_blackOne1" }, "Total Data"),
                React.createElement(Col, { className: "px-0 DMSanM_14_500 txt_blackOne1 taRight" }, addCommas(padZeros(totalData, 2, false, true)))))));
};
export default DelayedFno;
